import { render, staticRenderFns } from "./feautred_products.vue?vue&type=template&id=35a632ec&"
import script from "./feautred_products.vue?vue&type=script&lang=js&"
export * from "./feautred_products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports